module.exports = window.wp?.data;